import { userApiClient } from '../HttpClient';
import {
  API_ADMIN_STATS,
  API_ADMIN_USERS,
  API_ADMIN_USER_TOGGLE_ACTIVE,
  API_ADMIN_ORGANIZATIONS,
  API_ADMIN_VERIFICATIONS,
  API_ADMIN_VERIFICATION_REVIEW,
} from '../config';

export interface AdminStats {
  total_users: number;
  total_hosts: number;
  total_guests: number;
  total_admins: number;
  total_organizations: number;
  verified_organizations: number;
  pending_verifications: number;
}

export interface AdminUser {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  phone_number: string | null;
  role: string;
  is_active: boolean;
  date_joined: string;
}

export interface AdminOrganization {
  id: string;
  name: string;
  owner_email: string;
  is_verified: boolean;
  member_count: number;
  verification_status: string | null;
}

export interface AdminVerification {
  id: string;
  organization: string;
  organization_name: string;
  owner_email: string;
  document_type: string;
  document: string;
  status: string;
  admin_remarks: string | null;
  submitted_at: string;
}

export async function getAdminStats(): Promise<AdminStats> {
  const client = await userApiClient;
  return client.get<AdminStats>(API_ADMIN_STATS);
}

export async function getAdminUsers(params?: { role?: string; is_active?: string; search?: string }): Promise<AdminUser[]> {
  const client = await userApiClient;
  const filtered = Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== undefined && v !== ''));
  const query = new URLSearchParams(filtered).toString();
  return client.get<AdminUser[]>(`${API_ADMIN_USERS}${query ? `?${query}` : ''}`);
}

export async function toggleUserActive(pk: string): Promise<{ id: string; is_active: boolean }> {
  const client = await userApiClient;
  return client.patch<{ id: string; is_active: boolean }>(API_ADMIN_USER_TOGGLE_ACTIVE(pk), {});
}

export async function getAdminOrganizations(params?: { is_verified?: string }): Promise<AdminOrganization[]> {
  const client = await userApiClient;
  const filtered = Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== undefined && v !== ''));
  const query = new URLSearchParams(filtered).toString();
  return client.get<AdminOrganization[]>(`${API_ADMIN_ORGANIZATIONS}${query ? `?${query}` : ''}`);
}

export async function getAdminVerifications(params?: { status?: string }): Promise<AdminVerification[]> {
  const client = await userApiClient;
  const filtered = Object.fromEntries(Object.entries(params || {}).filter(([, v]) => v !== undefined && v !== ''));
  const query = new URLSearchParams(filtered).toString();
  return client.get<AdminVerification[]>(`${API_ADMIN_VERIFICATIONS}${query ? `?${query}` : ''}`);
}

export async function reviewVerification(pk: string, data: { status: string; admin_remarks?: string }): Promise<AdminVerification> {
  const client = await userApiClient;
  return client.patch<AdminVerification>(API_ADMIN_VERIFICATION_REVIEW(pk), data);
}
